import { errorNotifier, successNotifier } from '../../../components/NotificationHandler';
import http, { AUTH_ROUTES } from '../../../services/api';

export const editErrandBoy = async (payload, setLoading, onClose) => {
  try {
    await http.put(AUTH_ROUTES.EDIT_ERRAND_BOY(payload.userId, payload._id), payload);
    setLoading(false);
    successNotifier('Errand Boy edited successfully');
    onClose();
  } catch (e) {
    setLoading(false);
    errorNotifier(e?.response?.data);
  } finally {
    setLoading(false);
  }
};
